/* RefinementTag.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./RefinementTag.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from 'react';
import { useIntl } from 'react-intl-next';
import Tag, { SimpleTag } from '@atlaskit/tag';
import messages from './messages';
var cssVars = {
  alignItems: '--align-items',
  elemBeforeHeight: '--elem-before-height'
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var refinementTagStylesVisualRefresh = null;

/**
 * RefinementTag is the component which renders the
 * title of preset prompts such as
 * - Brainstorm
 * - Summarize
 *
 * When rendered as part of a user input field, it should provide an
 * onClick to display the remove button to allow users to remove the tag.
 * When rendered as a presentational element to show which
 * preset prompt has been used, it should not provide an onClick
 * to keep the tag presentational.
 */
export var RefinementTag = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    elemBefore = _ref.elemBefore,
    appearance = _ref.appearance;
  var styles = _defineProperty(_defineProperty({}, cssVars.alignItems, appearance === 'rounded' ? 'center' : 'flex-start'), cssVars.elemBeforeHeight, appearance === 'rounded' ? '100%' : 'auto');
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_1e0c1txw _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _18vqozcs _1k2cidpf _b3iiidpf _spswp0j8 _qxh5o3gi", "refinement-tag"]),
    "data-testid": "command-palette-refinement-tag",
    role: "status",
    "aria-atomic": "true",
    "aria-label": formatMessage(messages.promptSelected, {
      promptName: label
    }),
    "aria-live": "assertive",
    ref: ref,
    style: _objectSpread(_objectSpread({}, styles), {}, {
      "--_6ykse2": ix("var(".concat(cssVars.alignItems, ")")),
      "--_gild2u": ix("var(".concat(cssVars.elemBeforeHeight, ")"))
    })
  }, !onClick ? /*#__PURE__*/React.createElement(SimpleTag, {
    testId: 'refinement-tag',
    text: label,
    elemBefore: elemBefore,
    appearance: appearance
  }) : /*#__PURE__*/React.createElement(Tag, {
    appearance: appearance,
    elemBefore: elemBefore,
    testId: 'refinement-tag',
    removeButtonLabel: formatMessage(messages.removeLabel),
    text: label,
    onBeforeRemoveAction: function onBeforeRemoveAction() {
      onClick();
      return false;
    }
  }));
});